<div class="user-settings-page jhm-page" [class.mobile]="isMobile">
  <div class="jhm-top-toolbar">
	<div class="left">
	  <div class="back">
		<button (click)="goToPreviousPage()">
		  <img src="./assets/images/arrow-left.svg">
		</button>
	  </div>
	  <div class="navigation-item" [class.focus]="selectedPage ==='ACCOUNT'">
		<button (click)="switchPage('ACCOUNT')">
		  Account
		</button>
	  </div>
	  <div class="navigation-item" [class.focus]="selectedPage ==='HISTORY'">
		<button (click)="switchPage('HISTORY')">
		  Credit History
		</button>
	  </div>
	</div>
  </div>

  @if (selectedPage ==='ACCOUNT') {
	@if (userState) {
	  <div class="account-view" [class.mobile]="isMobile">
		<div class="account-view-left">
		  <div class="name-and-actions">
			<div class="name-and-username">
			  <div class="full-name">{{userState.name}}</div>
			  <div class="username">{{userState.username}}</div>
			  <div [class.warn]="userState.credits <= 5" class="credits">
				<div class="icon"><i class="fa-solid fa-envelope-open-dollar" [class.c-danger]="userState.credits <= 5" [class.c-primary]="userState.credits > 5"></i></div>
				<div class="details">
				  <div class="description">You have:</div>
				  <div class="count">{{userState.credits | centsToDollars}}</div>
				</div>
			  </div>
			</div>
			<div class="action-items">
			  <div class="section-header">My Controls</div>
			  <a class="action-item" (click)="changePassword()"><i class="fa-light fa-key"></i><span>Change Password</span></a>
			  <a class="action-item" (click)="purchaseCredits()"><i class="fa-light fa-circle-dollar"></i><span>Purchase Credit</span></a>
			  <!-- I think we want to leave this option available to all civilians, but tell them when selecting inmates who can and can't receive credits, update: I think we
			   only show them this if they have at least one contact that they can give credits to, if they have no one, don't show the option -->
			@if (civilianSettings?.showInmatePortalFeatures) 
			{
				<a class="action-item" (click)="giveCredits()"><i class="fa-light fa-arrows-left-right"></i><span>Give Credit</span></a>
			}
			  <a class="action-item" (click)="connectInmateAccount()"><i class="fa-light fa-link-horizontal"></i><span>Connect Inmate Account</span></a>
			  <!-- <a class="action-item warning" (click)="deleteAccountClicked()"><i class="fa-light fa-user-slash"></i><span>Delete Account</span></a> -->
			</div>
		  </div>
		</div>
		<div class="account-view-right">
		  <div class="form-section">
			<div class="form-item">
			  <div class="input-title">Email</div>
			  <mat-form-field appearance="outline">
				<input matInput [(ngModel)]="newEmail" placeholder="Email" [disabled]="true" />
			  </mat-form-field>
			</div>
		  </div>
		  <!-- <div class="form-section">
			<div class="form-item">
			  <button class="jhm-button" [class.disabled]="newEmail === userState.currentEmailOrBookingNumber" (click)="verifyEmail()">Verify Email</button>
			</div>
		  </div> -->
		</div>
	  </div>
	}
  }

  @if (selectedPage ==='HISTORY') {
	<jhm-table
	  [repository]="userCreditHistoryRepository"
	  (cellClicked)="transactionClicked($event)"
	  [showHeaders]="false">
	</jhm-table>
  }

</div>

@if (showStripeModal) {
  <jhm-stripe-purchase (exit)="showStripeModal = false;"></jhm-stripe-purchase>
}
@if (showGiveCreditsModal) {
  <jhm-give-credits (exit)="showGiveCreditsModal = false;"></jhm-give-credits>
}
@if (showConnectInmateModal) {
  <jhmc-connect-inmate (exit)="showConnectInmateModal = false;"></jhmc-connect-inmate>
}
@if (showConfirmDeleteAccount) {
	<div class="jhm-modal-background">
		<div id="delete-account-modal" class="jhm-modal delete-account-modal">
			<header>
				<h2>Delete Jailhouse Mail Account</h2>
			</header>
			<div class="sub-title">
				Are you sure you would like to delete your Jailhouse Mail account?
			</div>
			<div>
				This action cannot be undone.  All of your data (messages, contacts, credit history) and unused credit will be lost.
			</div>
			<footer class="filled">
				<button class="jhm-button" (click)="showConfirmDeleteAccount = false">Cancel</button>
				<button class="jhm-button danger" (click)="confirmDeleteAccount()">Delete My Account</button>
			</footer>
		</div>
	</div>
}

@if (showChangePasswordModal) {
  <div class="jhm-modal-background">
	<div id="change-password-modal" class="jhm-modal delete-draft-modal">
	  <button class="jhm-icon-button transparent close-modal-button" (click)="showChangePasswordModal = false"><i class="fa-regular fa-times"></i></button>
	  <header>
		<h2>Change Password</h2>
	  </header>
	  <div>
		<jhm-change-password
		  #changePasswordComponent
		  [username]="userState.username"
          (valid)="passwordsValid = $event"
		(closeModal)="showChangePasswordModal = false"></jhm-change-password>
	  </div>
	  <footer class="filled">
		<button class="jhm-button" (click)="showChangePasswordModal = false">Cancel</button>
		<button [class.disabled]="!passwordsValid" class="jhm-button primary" (click)="changePasswordConfirm()">Change Password</button>
	  </footer>
	</div>
  </div>
}
@if (selectedHistory) {
  <div class="jhm-modal-background">
	<div id="view-history-detail-modal" class="jhm-modal view-history-detail-modal">
	  @if (selectedHistory.type === 'PURCHASE') {
		<div class="credit-detail">
		  <div class="icon-and-exit">
			<div class="background-circle">
			  <img class="purchase" src="./assets/images/cart-check.svg">
			</div>
			<img class="exit" src="./assets/images/black-x.svg" (click)="selectedHistory = null">
		  </div>
		  <div class="summary">
			You purchased <span class="bolded colored">{{selectedHistory.creditAmount | centsToDollars}}</span> in credit on {{getDateSecondsSinceEpoch(selectedHistory.instantSeconds)}}
		  </div>
		  <div class="horizontal-line line"></div>
		  <div class="line-item">
			<div>
			  Order Number
			</div>
			<div class="line-item-value">
			  {{selectedHistory.id}}
			</div>
		  </div>
		  <div class="horizontal-line line"></div>
		  <div class="line-item">
			<div>
			  {{selectedHistory.creditAmount | centsToDollars}} in credit
		  </div>
		  <div class="line-item-value">
			${{selectedHistory.creditCost}}
		  </div>
		</div>
		<div class="line-item">
		  <div>
			Tax
		  </div>
		  <div class="line-item-value">
			${{selectedHistory.taxCost}}
		  </div>
		</div>
		<div class="horizontal-line line"></div>
		<div class="line-item">
		  <div>
			Total
		  </div>
		  <div class="line-item-value">
			${{selectedHistory.totalCost}}
		  </div>
		</div>
	  </div>
	}
	@if (selectedHistory.type === 'INMATE_GIFT') {
	  <div class="credit-detail">
		<div class="icon-and-exit">
		  <div class="background-circle">
			<img class="purchase" src="./assets/images/credit-give-blue.svg">
		  </div>
		  <img class="exit" src="./assets/images/black-x.svg" (click)="selectedHistory = null">
		</div>
		<div class="summary">
		  You gave <span class="bolded colored">{{myMath.abs(selectedHistory.creditAmount) | centsToDollars}} </span> to <span class="bolded">{{selectedHistory.inmateFirstName}} {{selectedHistory.inmateLastName}}</span> on {{getDateSecondsSinceEpoch(selectedHistory.instantSeconds)}}
		</div>
		<div class="horizontal-line line"></div>
		<div class="line-item">
		  <div>
			Date
		  </div>
		  <div class="line-item-value">
			{{getDateSecondsSinceEpoch(selectedHistory.instantSeconds)}}
		  </div>
		</div>
		<div class="line-item">
		  <div>
			Recipient
		  </div>
		  <div class="line-item-value">
			{{selectedHistory.inmateFirstName}} {{selectedHistory.inmateLastName}}
		  </div>
		</div>
		<div class="horizontal-line line"></div>
		<div class="line-item">
		  <div>
			Amount
		  </div>
		  <div class="line-item-value">
			{{myMath.abs(selectedHistory.creditAmount) | centsToDollars}}
		</div>
	  </div>
	</div>
  }
  @if (selectedHistory.type === 'PAY_COLLECT_MESSAGE') {
	<div class="credit-detail">
	  <div class="icon-and-exit">
		<div class="background-circle">
		  <img class="purchase" src="./assets/images/credit-give-blue.svg">
		</div>
		<img class="exit" src="./assets/images/black-x.svg" (click)="selectedHistory = null">
	  </div>
	  <div class="summary">
		You purchased a collect message from <span class="bolded">{{selectedHistory.inmateFirstName}} {{selectedHistory.inmateLastName}}</span> on {{getDateSecondsSinceEpoch(selectedHistory.instantSeconds)}} for <span class="bolded colored">{{myMath.abs(selectedHistory.creditAmount) | centsToDollars}}</span>
	</div>
	<div class="horizontal-line line"></div>
	<div class="line-item">
	  <div>
		Date
	  </div>
	  <div class="line-item-value">
		{{getDateSecondsSinceEpoch(selectedHistory.instantSeconds)}}
	  </div>
	</div>
	<div class="horizontal-line line"></div>
	<div class="line-item">
	  <div>
		Amount
	  </div>
	  <div class="line-item-value">
		{{myMath.abs(selectedHistory.creditAmount) | centsToDollars}}
	</div>
  </div>
</div>
}
@if (selectedHistory.type === 'SEND_MESSAGE') {
  <div class="credit-detail">
	<div class="icon-and-exit">
	  <div class="background-circle">
		<img class="purchase" src="./assets/images/credit-give-blue.svg">
	  </div>
	  <img class="exit" src="./assets/images/black-x.svg" (click)="selectedHistory = null">
	</div>
	<div class="summary">
	  You sent a message to <span class="bolded">{{selectedHistory.inmateFirstName}} {{selectedHistory.inmateLastName}}</span> on {{getDateSecondsSinceEpoch(selectedHistory.instantSeconds)}} for <span class="bolded colored">{{myMath.abs(selectedHistory.creditAmount) | centsToDollars}}</span>
  </div>
  <div class="horizontal-line line"></div>
  <div class="line-item">
	<div>
	  Date
	</div>
	<div class="line-item-value">
	  {{getDateSecondsSinceEpoch(selectedHistory.instantSeconds)}}
	</div>
  </div>
  <div class="horizontal-line line"></div>
  <div class="line-item">
	<div>
	  Amount
	</div>
	<div class="line-item-value">
	  {{selectedHistory.creditAmount | centsToDollars}}
	</div>
  </div>
</div>
}
</div>
</div>
}
@if (loading) {
  <jhm-loading></jhm-loading>
}